export const NOTIFICATION_SUBSCRIBE_REQUEST = 'NOTIFICATION_SUBSCRIBE_REQUEST';
export const NOTIFICATION_SUBSCRIBE_SUCCESS = 'NOTIFICATION_SUBSCRIBE_SUCCESS';
export const NOTIFICATION_SUBSCRIBE_FAIL = 'NOTIFICATION_SUBSCRIBE_FAIL';

export const NOTIFICATION_UNSUBSCRIBE_REQUEST = 'NOTIFICATION_UNSUBSCRIBE_REQUEST';
export const NOTIFICATION_UNSUBSCRIBE_SUCCESS = 'NOTIFICATION_UNSUBSCRIBE_SUCCESS';
export const NOTIFICATION_UNSUBSCRIBE_FAIL = 'NOTIFICATION_UNSUBSCRIBE_FAIL';